import { useState, useRef } from "react";
import { useUser } from "context/UserContext";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faUser,
  faChevronUp,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

export default function ProfileDropdown({ collapsed = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const { logout } = useUser();
  const navigate = useNavigate();
  const dropDownRef = useRef(null);
  const profileButtonRef = useRef(null);
  const { derivedState } = useUser();

  const toggleDropdown = (event) => {
    event.stopPropagation(); // Prevent event bubbling to parent elements
    
    if (profileButtonRef.current) {
      const rect = profileButtonRef.current.getBoundingClientRect();
      const dropdownHeight = 200; // Approximate height of dropdown
      const dropdownWidth = 200; // Width of dropdown
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      
      let top, left;
      
      if (collapsed) {
        // When collapsed, show dropdown to the right of the sidebar
        top = rect.top - 20; // Move up by 20px
        left = rect.right + 10;
        
        // Check if dropdown would go off the right edge
        if (left + dropdownWidth > windowWidth) {
          left = rect.left - dropdownWidth - 10;
        }
        
        // Check if dropdown would go off the top edge
        if (top < 0) {
          top = 10;
        }
        
        // Check if dropdown would go off the bottom edge
        if (top + dropdownHeight > windowHeight) {
          top = windowHeight - dropdownHeight - 10;
        }
      } else {
        // When expanded, show dropdown above the profile section
        top = rect.top - dropdownHeight - 20; // Move up by additional 20px
        left = rect.right - dropdownWidth;
        
        // Check if dropdown would go off the top edge
        if (top < 0) {
          top = rect.bottom + 10;
        }
        
        // Check if dropdown would go off the left edge
        if (left < 0) {
          left = 10;
        }
        
        // Check if dropdown would go off the bottom edge
        if (top + dropdownHeight > windowHeight) {
          top = windowHeight - dropdownHeight - 10;
        }
      }
      
      setDropdownPosition({ top, left });
    }
    
    setIsOpen((prev) => !prev);
  };

  // Removed the old click outside handler since we now use a backdrop

    return derivedState ? (
    <div className="dropdown profile-dropdown" ref={dropDownRef}>
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="tooltip-profile" style={{ zIndex: 10000 }}>
            Profile
          </Tooltip>
        }
        show={collapsed ? undefined : false}
        trigger={collapsed ? ["hover"] : []}
      >
        <div
          ref={profileButtonRef}
          className="d-flex align-items-center"
          onClick={toggleDropdown}
          style={{ 
            cursor: "pointer",
            padding: collapsed ? "10px" : "10px 15px",
            borderRadius: 8,
            background: "transparent",
            transition: "background-color 0.2s",
            justifyContent: collapsed ? "center" : "flex-start",
            width: collapsed ? "100%" : "auto"
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = "#EDEDED"}
          onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
        >
          <img
            src="/back1.jpg" // Replace with the path to your image
            alt="Profile"
            width={25} // Adjust size as needed
            height={25} // Adjust size as needed
            className="rounded-circle border border-dark"
            style={{ marginRight: collapsed ? 0 : 16 }}
          />
          {!collapsed && (
            <>
              <span style={{ flex: 1, marginLeft: 0 }}>
                {derivedState.authenticateResponse?.username}
              </span>
              <FontAwesomeIcon
                icon={isOpen ? faChevronUp : faChevronDown}
                style={{ marginLeft: 8 }}
              />
            </>
          )}
        </div>
      </OverlayTrigger>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 9998,
              backgroundColor: "transparent"
            }}
            onClick={() => setIsOpen(false)}
          />
          {/* Dropdown */}
          <div
            className="dropdown-menu show mt-2"
            style={{ 
              minWidth: "200px", 
              position: "fixed",
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              zIndex: 9999,
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              backgroundColor: "white",
              border: "1px solid #dee2e6",
              borderRadius: "8px"
            }}
          >
          <div
            className="p-2 border-bottom"
            style={{ 
              display: "flex", 
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #dee2e6"
            }}
          >
            <img
              src="/back1.jpg" // Replace with the path to your image
              alt="Profile"
              width={25}
              height={25}
              className="rounded-circle"
              style={{ marginRight: "8px" }}
            />
            <strong style={{ fontSize: "14px" }}>{derivedState.authenticateResponse?.username}</strong>
          </div>

          <button 
            className="dropdown-item" 
            style={{ 
              cursor: "pointer",
              padding: "8px 16px",
              border: "none",
              background: "transparent",
              width: "100%",
              textAlign: "left"
            }}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={(e) => e.currentTarget.style.background = "#f8f9fa"}
            onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
          >
            <FontAwesomeIcon icon={faUser} className="me-2" />
            My Account
          </button>
          <button
            className="dropdown-item"
            onClick={(e) => {
              e.stopPropagation();
              logout();
            }}
            style={{ 
              cursor: "pointer",
              padding: "8px 16px",
              border: "none",
              background: "transparent",
              width: "100%",
              textAlign: "left"
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = "#f8f9fa"}
            onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
          >
            <FontAwesomeIcon icon={faRightFromBracket} className="me-2" />
            Logout
          </button>

          <div className="dropdown-divider"></div>
          <div className="d-flex justify-content-around" style={{ padding: "8px 16px" }}>
            <button
              className="text-muted small"
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
                navigate("/privacy");
              }}
              style={{
                background: "none",
                border: "none",
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: "12px",
                color: "#6c757d"
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#495057"}
              onMouseLeave={(e) => e.currentTarget.style.color = "#6c757d"}
            >
              Privacy
            </button>
            <button
              className="text-muted small"
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "none",
                border: "none",
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: "12px",
                color: "#6c757d"
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#495057"}
              onMouseLeave={(e) => e.currentTarget.style.color = "#6c757d"}
            >
              Cookies
            </button>
            <button
              className="text-muted small"
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(false);
                navigate("/terms");
              }}
              style={{
                background: "none",
                border: "none",
                padding: "4px 8px",
                cursor: "pointer",
                fontSize: "12px",
                color: "#6c757d"
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#495057"}
              onMouseLeave={(e) => e.currentTarget.style.color = "#6c757d"}
            >
              Terms
            </button>
          </div>
        </div>
        </>
      )}
    </div>
  ) : null;
}
